import { render, staticRenderFns } from "./pc-footer.vue?vue&type=template&id=82c3af5e&scoped=true"
import script from "./pc-footer.vue?vue&type=script&lang=js"
export * from "./pc-footer.vue?vue&type=script&lang=js"
import style0 from "./pc-footer.vue?vue&type=style&index=0&id=82c3af5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c3af5e",
  null
  
)

export default component.exports